<template>
  <div class="section">
    <div class="block mb-6">
      <h1 class="title is-3 has-text-centered">PASSENDE ANALYSE FINDEN</h1>
      <div class="is-flex is-justify-content-center">
        <SearchBar
          hideCloseBtn
          showTopTags
          showHint
          :limit="parseInt(4, 10)"
          style="width: 768px"
        />
      </div>
    </div>
    <div class="container">
      <div class="block mb-6">
        <h1 class="title is-3 has-text-centered">NEUIGKEITEN</h1>
        <hr />
        <NewsCarousel />
      </div>

      <div class="block mb-6">
        <h1 class="title is-3 has-text-centered">IHRE ABONNEMENTS</h1>
        <hr />
        <ProductCardList />
      </div>
    </div>
  </div>
</template>

<script>
import NewsCarousel from '@/components/editNews/NewsCarousel.vue';
import ProductCardList from '@/components/editProduct/ProductCardList.vue';
import SearchBar from '@/components/SearchBar.vue';

export default {
  name: 'Home',
  components: {
    NewsCarousel,
    ProductCardList,
    SearchBar,
  },
};
</script>
<style>
</style>
